import { apiService } from "./apiService";

export const getBillingAccounts = async () =>
  apiService.request("/client-admin/billing-accounts", { method: "GET" });

export const updateBillingAccounts = async (data) =>
  apiService.request("/client-admin/billing-accounts", {
    method: "PUT",
    body: JSON.stringify(data),
  });
